import { useState, useEffect } from 'react'

function getStorageValue (key, defaultValue) {
	if (typeof window !== 'undefined') {
		const saved = localStorage.getItem(key)
		let initial
		try {
			initial = JSON.parse(saved)
		} catch (e) {
			initial = JSON.parse(JSON.stringify(saved))
		}
		return initial || defaultValue
	}
}

export function useLocalStorage (key, defaultValue) {
	const [value, setValue] = useState(() => {
		return getStorageValue(key, defaultValue)
	})

	useEffect(() => {
		let valueToSave
		if (typeof value === 'string') {
			valueToSave = value
		} else {
			valueToSave = JSON.stringify(value)
		}
		localStorage.setItem(key, valueToSave)
	}, [key, value])

	return [value, setValue]
}
